import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './want-to-menu.component.scss';
var WantToMenu = /** @class */ (function (_super) {
    tslib_1.__extends(WantToMenu, _super);
    function WantToMenu(element) {
        return _super.call(this, element) || this;
    }
    WantToMenu.prototype.init = function () { };
    WantToMenu.prototype.bindEvents = function () { };
    return WantToMenu;
}(Base));
export { WantToMenu };



//////////////////
// WEBPACK FOOTER
// ./components/want-to-menu/want-to-menu.component.ts
// module id = 563
// module chunks = 0